import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../service/navigation.service';
import { NotificationBarService } from '../../service/notification-bar.service';
import { Params } from '@angular/router';

@Component({
    selector: 'app-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationBarComponent implements OnDestroy, OnInit {
  constructor(
    private _navigation: NavigationService,
    notificationService: NotificationBarService
  ) {
    this._subscription = notificationService.notifications.subscribe(notification => {
      if (notification) {
        this.processing = !this.processing;
        this.show = true;
        this.message = notification.message;
        if (notification.link) {
          this.navigationContext = {
            caption: notification.link.caption,
            params: notification.link.params,
            routerCommands: notification.link.routerCommands,
          };
        }
      }
    });
  }

  private _subscription: Subscription;
  message: string;
  navigationContext: { caption: string; routerCommands: string[]; params: Params };
  processing: boolean;
  show: boolean = true;

  private _close() {
    this.message = null;
    this.show = false;
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }

  ngOnInit() {}

  onClick() {
    this.show = !this.show;
    if (!this.processing) {
      this._close();
    }
  }

  onLinkClick() {
    if (this.navigationContext) {
      this._navigation.navigate(this.navigationContext.routerCommands, { queryParams: this.navigationContext.params }).then(() => {
        this._close();
      });
    }
  }
}
